import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { impl } from '@/main';
import { useAuthStore } from '../hooks/useAuthStore';

// Temporary solution to manage authState based on token
const AuthTokenWrapper = () => {
  const authStore = useAuthStore();
  useEffect(() => {
    const checkToken = async () => {
      const token = await impl.init();
      if (token.success && (!authStore.getIsAuthenticated() || !authStore.isInitialized)) {
        authStore.authenticateUser(token.data);
      } else if (!token.success && !authStore.isInitialized) {
        authStore.unauthenticateUser();
      }
    };
    if (!authStore.getIsAuthenticated()) {
      checkToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
};

export default AuthTokenWrapper;
